import React, { useEffect } from "react";
import { useUpdateAboutAndSustainabilityContentMutation } from "../../../../store/services/AboutAndSustainabilityContentService";
import { Button, Col, Row, Tab, Nav } from "react-bootstrap";
import toast from "react-hot-toast";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import Dropzone from "../../../../components/Dropzone/Dropzone";
import { MdAdd, MdDelete } from "react-icons/md";
//import CKEditorField from "../../../../components/ckEditor/CKEditorField";
import CKEditorNew from "../../../../components/newCkEditor/ckEditor";

function AboutAndSustainabilityContentForm({ data }) {
  const [updateAboutAndSustainability, { isLoading: isUpdating }] =
    useUpdateAboutAndSustainabilityContentMutation();
  const { createdAt, updatedAt, ...PageInfo } = data;

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm({
    mode: "onTouched",
    defaultValues: { ...PageInfo },
  });

  const {
    fields: generalDetailsFields,
    append: appendGeneralDetail,
    remove: removeGeneralDetail,
  } = useFieldArray({
    control,
    name: "generalDetails",
  });

  const {
    fields: sustainabilityCardsFields,
    append: appendSustainabilityCardsDetail,
    remove: removeSustainabilityCardsDetail,
  } = useFieldArray({
    control,
    name: "sustainabilityCards",
  });

  const {
    fields: cardFields,
    append: appendCard,
    remove: removeCard,
  } = useFieldArray({
    control,
    name: "whyChooseUs.featureBenefitKalofy",
  });

  const onSubmit = async (data) => {
    try {
      const res = await updateAboutAndSustainability({
        updatedData: data,
      });
      if (res?.data?.status === "success") {

        return toast.success(res?.data?.message);
      }
    } catch (error) {
      console.error("Failed to delete the meal:", error); // Handle error
    }
  };

  useEffect(() => {
    let toastId;

    if (isUpdating) {
      // Show loading toast and save the ID
      toastId = toast.loading("Updating...");
    } else if (toastId) {
      // Dismiss the loading toast when isUpdating is false
      toast.dismiss(toastId);
    }

    return () => {
      // Cleanup: Ensure toast is dismissed if the component unmounts
      if (toastId) {
        toast.dismiss(toastId);
      }
    };
  }, [isUpdating]);

  return (
    <Col lg="12" md="12" sm="12" className="my-2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div
          className="formWrpper px-lg-5 p-md-4 p-3 rounded"
          style={{ background: "#EEEEEE" }}
        >
          <Row className="justify-content-between">
            <Col lg="12">
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey="aboutUs"
              >

                <Nav
                  variant="pills"
                  className="inline-flex pillsTab gap-10 pb-2"
                  style={{
                    // background: "#033E8A",
                    maxWidth: "max-content",
                  }}
                >
                  <Nav.Item>
                    <Nav.Link
                      className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                      eventKey="aboutUs"
                    >
                      About Us
                    </Nav.Link>
                  </Nav.Item>


                  <Nav.Item>
                    <Nav.Link
                      className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                      eventKey="sustainability"
                    >
                      Sustainability
                    </Nav.Link>
                  </Nav.Item>

                </Nav>


                <Tab.Content className="pt-3">
                  <Tab.Pane eventKey="aboutUs">
                    <Row>
                      <Col lg="12">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          About us page content
                        </h4>
                      </Col>

                      <Col lg="6" md="6" sm="6" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            About us title
                          </label>
                          <input
                            type="text"
                            {...register("aboutUs.title", {
                              required: "Please enter about us title",
                            })}
                            className={`form-control ${errors?.aboutUs?.title ? "is-invalid" : ""
                              }`}
                          />
                          {errors?.aboutUs?.title && (
                            <span className="text-danger">
                              {errors?.aboutUs?.title?.message}
                            </span>
                          )}
                        </div>
                      </Col>
                      <Col lg="6" md="6" sm="6" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            About us sub title
                          </label>
                          <input
                            type="text"
                            {...register("aboutUs.subTitle", {
                              required: "Please enter about us sub title",
                            })}
                            className={`form-control ${errors?.aboutUs?.subTitle ? "is-invalid" : ""
                              }`}
                          />
                          {errors?.aboutUs?.subTitle && (
                            <span className="text-danger">
                              {errors?.aboutUs?.subTitle?.message}
                            </span>
                          )}
                        </div>
                      </Col>

                      <Col lg="12" md="12" sm="12" className="mb-3">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            About us image
                          </label>
                          <Controller
                            name="aboutUs.image"
                            control={control}
                            rules={{ required: "About us image is required" }}
                            render={({ field }) => (
                              <Dropzone
                                field="aboutUs.image"
                                setFieldValue={setValue}
                                value={field.value}
                                error={errors}
                              />
                            )}
                          />
                          {errors?.aboutUs?.image && (
                            <span className="text-danger">
                              {errors?.aboutUs?.image?.message}
                            </span>
                          )}
                        </div>
                      </Col>

                      <Col lg="12">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          General details
                        </h4>
                      </Col>

                      {generalDetailsFields.map((field, index) => (
                        <div key={field.id} className="row">
                          {/* Image Field with Dropzone */}
                          <Col lg="12" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                General detail image
                              </label>
                              <Controller
                                name={`generalDetails.${index}.image`}
                                control={control}
                                rules={{ required: "General detail image is required" }}
                                render={({ field }) => (
                                  <Dropzone
                                    field={`generalDetails.${index}.image`}
                                    setFieldValue={setValue}
                                    value={field.value}
                                    error={errors?.generalDetails?.[index]?.image}
                                  />
                                )}
                              />
                              {errors?.generalDetails?.[index]?.image && (
                                <span className="text-danger">
                                  {errors?.generalDetails?.[index].image.message}
                                </span>
                              )}
                            </div>
                          </Col>


                          {/* Title Field */}
                          {/* <Col lg="4" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      General detail title
                    </label>
                    <input
                      type="text"
                      {...register(`generalDetails.${index}.title`, {
                        required: "Please enter general detail title",
                      })}
                      className={`form-control ${errors?.generalDetails?.[index]?.title
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                    {errors?.generalDetails?.[index]?.title && (
                      <span className="text-danger">
                        {errors?.generalDetails?.[index]?.title.message}
                      </span>
                    )}
                  </div>
                </Col> */}

                          {/* Description Field */}
                          {/* <Col lg="6" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      General detail description
                    </label>
                    <input
                      type="text"
                      {...register(`generalDetails.${index}.description`, {
                        required: "Please enter general detail description",
                      })}
                      className={`form-control ${errors?.generalDetails?.[index]?.description
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                    {errors?.generalDetails?.[index]?.description && (
                      <span className="text-danger">
                        {errors?.generalDetails?.[index]?.description.message}
                      </span>
                    )}
                  </div>
                  </Col> */}


                          <Col lg="12" md="12" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                General detail description
                              </label>

                              <Controller
                                name={`generalDetails.${index}.description`}
                                control={control}
                                rules={{ required: "Please enter a general detail description" }}
                                render={({ field }) => (
                                  <CKEditorNew
                                    field={field.name}
                                    setFieldValue={setValue}
                                    value={field.value}
                                    error={errors?.generalDetails?.[index]?.description}
                                    placeholder="Type your description here..."
                                  />
                                )}
                              />

                              {errors?.generalDetails?.[index]?.description && (
                                <span className="text-danger">
                                  {errors.generalDetails[index].description.message}
                                </span>
                              )}
                            </div>
                          </Col>



                          {/* Remove Button */}
                          <Col lg="12" className="text-right">
                            <Button
                              type="button"
                              variant="danger"
                              onClick={() => removeGeneralDetail(index)}
                              className="mt-2"
                            >
                              <MdDelete />
                            </Button>
                          </Col>
                        </div>
                      ))}
                      <Col lg="12" className="text-right mt-3">
                        <Button
                          type="button"
                          color="primary"
                          onClick={() => appendGeneralDetail({ image: "", description: "", title: "" })}
                        >
                          <MdAdd />
                          General details
                        </Button>
                      </Col>

                    </Row>
                  </Tab.Pane>


                  {/* Why choose us */}

                  {/* <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                Why choose us
              </h4>
            </Col>

            <Col lg="6" className="my-2">
              <div className="py-2">
                <label className="form-label fw-sbold text-muted ps-2 m-0">
                  Why choose us title
                </label>
                <input
                  type="text"
                  {...register("whyChooseUs.title", {
                    required: "Please enter why choose us title",
                  })}
                  className={`form-control ${errors.whyChooseUs?.title ? "is-invalid" : ""
                    }`}
                />
                {errors.whyChooseUs?.title && (
                  <span className="text-danger">
                    {errors.whyChooseUs.title.message}
                  </span>
                )}
              </div>
            </Col> */}

                  {/* Why Choose Us: SubTitle */}
                  {/* <Col lg="6" className="my-2">
              <div className="py-2">
                <label className="form-label fw-sbold text-muted ps-2 m-0">
                  Why choose us sub title
                </label>
                <input
                  type="text"
                  {...register("whyChooseUs.subTitle", {
                    required: "Please enter why choose us sub title",
                  })}
                  className={`form-control ${errors.whyChooseUs?.subTitle ? "is-invalid" : ""
                    }`}
                />
                {errors.whyChooseUs?.subTitle && (
                  <span className="text-danger">
                    {errors.whyChooseUs.subTitle.message}
                  </span>
                )}
              </div>
            </Col> */}


                  {/* Why choose us = feature title */}

                  {/* <Col lg="6" className="my-2">
              <div className="py-2">
                <label className="form-label fw-sbold text-muted ps-2 m-0">
                  Why choose us feature title
                </label>
                <input
                  type="text"
                  {...register("whyChooseUs.featureTitle", {
                    required: "Please enter why choose us feature title",
                  })}
                  className={`form-control ${errors.whyChooseUs?.featureTitle ? "is-invalid" : ""
                    }`}
                />
                {errors.whyChooseUs?.featureTitle && (
                  <span className="text-danger">
                    {errors.whyChooseUs.featureTitle.message}
                  </span>
                )}
              </div>
            </Col> */}



                  {/* Why Choose Us: Card Array */}
                  {/* {cardFields.map((field, index) => (
              <div key={field.id} className="row">
                
                <Col lg="4" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Why choose us card icon
                    </label>
                    <Controller
                      name={`whyChooseUs.featureBenefitKalofy.${index}.icon`}
                      control={control}
                      rules={{ required: "Please enter why choose us icon" }}
                      render={({ field }) => (
                        <Dropzone
                          field={`whyChooseUs.featureBenefitKalofy.${index}.icon`}
                          setFieldValue={setValue}
                          value={field.value}
                          error={errors.whyChooseUs?.featureBenefitKalofy?.[index]?.icon}
                        />
                      )}
                    />
                    {errors.whyChooseUs?.featureBenefitKalofy?.[index]?.icon && (
                      <span className="text-danger">
                        {errors.whyChooseUs.featureBenefitKalofy[index].icon.message}
                      </span>
                    )}
                  </div>
                </Col>

               
                <Col lg="4" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Why choose us card title
                    </label>
                    <input
                      type="text"
                      {...register(`whyChooseUs.featureBenefitKalofy.${index}.title`, {
                        required: "Please enter why choose us card title",
                      })}
                      className={`form-control ${errors.whyChooseUs?.featureBenefitKalofy?.[index]?.title
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                    {errors.whyChooseUs?.featureBenefitKalofy?.[index]?.title && (
                      <span className="text-danger">
                        {errors.whyChooseUs.featureBenefitKalofy[index].title.message}
                      </span>
                    )}
                  </div>
                </Col>

              
                <Col lg="4" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Why choose us card description
                    </label>
                    <input
                      type="text"
                      {...register(`whyChooseUs.featureBenefitKalofy.${index}.desc`, {
                        required: "Please enter why choose us description",
                      })}
                      className={`form-control ${errors.whyChooseUs?.featureBenefitKalofy?.[index]?.desc
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                    {errors.whyChooseUs?.featureBenefitKalofy?.[index]?.desc && (
                      <span className="text-danger">
                        {errors.whyChooseUs.featureBenefitKalofy[index].desc.message}
                      </span>
                    )}
                  </div>
                </Col>

                
                <Col lg="12" className="text-right">
                  <Button
                    type="button"
                    variant="danger"
                    onClick={() => removeCard(index)}
                    className="mt-2"
                  >
                    <MdDelete />
                  </Button>
                </Col>
              </div>
            ))} */}


                  {/* <Col lg="12" className="text-right mt-3">
              <Button
                type="button"
                color="primary"
                onClick={() => appendCard({ icon: "", title: "", desc: "" })}
              >
                <MdAdd />
                Add why choose us card
              </Button>
            </Col> */}


                  <Tab.Pane eventKey="sustainability">
                    <Row>

                      {/* Sustainability */}

                      <Col lg="12">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          Sustainability
                        </h4>
                      </Col>

                      <Col lg="4" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Sustainability image
                          </label>
                          <Controller
                            name="sustainability.image"
                            control={control}
                            rules={{ required: "Sustainability image is required" }}
                            render={({ field }) => (
                              <Dropzone
                                field="sustainability.image"
                                setFieldValue={setValue}
                                value={field.value}
                                error={errors}
                              />
                            )}
                          />
                          {errors?.sustainability?.image && (
                            <span className="text-danger">
                              {errors?.sustainability?.image?.message}
                            </span>
                          )}
                        </div>
                      </Col>


                      <Col lg="4" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Sustainability Title
                          </label>
                          <input
                            type="text"
                            {...register("sustainability.tittle", {
                              required: "Please enter sustainability title",
                            })}
                            className={`form-control ${errors.sustainability?.tittle ? "is-invalid" : ""
                              }`}
                          />
                          {errors.sustainability?.tittle && (
                            <span className="text-danger">
                              {errors.sustainability.tittle.message}
                            </span>
                          )}
                        </div>
                      </Col>

                      <Col lg="4" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Sustainability description
                          </label>
                          <input
                            type="text"
                            {...register("sustainability.desc", {
                              required: "Please enter sustainability description",
                            })}
                            className={`form-control ${errors.sustainability?.desc ? "is-invalid" : ""
                              }`}
                          />
                          {errors.sustainability?.desc && (
                            <span className="text-danger">
                              {errors.sustainability.desc.message}
                            </span>
                          )}
                        </div>
                      </Col>




                      <Col lg="12">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          Sustainability cards
                        </h4>
                      </Col>




                      {sustainabilityCardsFields.map((field, index) => (
                        <div key={field.id} className="row">
                          {/* Image Field with Dropzone */}
                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Sustainability card image
                              </label>
                              <Controller
                                name={`sustainabilityCards.${index}.image`}
                                control={control}
                                rules={{ required: "Please enter sustainability card image" }}
                                render={({ field }) => (
                                  <Dropzone
                                    field={`sustainabilityCards.${index}.image`}
                                    setFieldValue={setValue}
                                    value={field.value}
                                    error={errors?.sustainabilityCards?.[index]?.image}
                                  />
                                )}
                              />
                              {errors?.sustainabilityCards?.[index]?.image && (
                                <span className="text-danger">
                                  {errors?.sustainabilityCards?.[index].image.message}
                                </span>
                              )}
                            </div>
                          </Col>


                          {/* Title Field */}
                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Sustainability card title
                              </label>
                              <input
                                type="text"
                                {...register(`sustainabilityCards.${index}.title`, {
                                  required: "Please enter sustainability card title",
                                })}
                                className={`form-control ${errors?.sustainabilityCards?.[index]?.title
                                  ? "is-invalid"
                                  : ""
                                  }`}
                              />
                              {errors?.sustainabilityCards?.[index]?.title && (
                                <span className="text-danger">
                                  {errors?.sustainabilityCards?.[index]?.title.message}
                                </span>
                              )}
                            </div>
                          </Col>

                          {/* Description Field */}
                          {/* <Col lg="4" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Sustainability card Description
                    </label>
                    <input
                      type="text"
                      {...register(`sustainabilityCards.${index}.desc`, {
                        required: "Please enter sustainability card description",
                      })}
                      className={`form-control ${errors?.sustainabilityCards?.[index]?.desc
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                    {errors?.sustainabilityCards?.[index]?.desc && (
                      <span className="text-danger">
                        {errors?.sustainabilityCards?.[index]?.desc.message}
                      </span>
                    )}
                  </div>
                </Col> */}

                          <Col lg="12" md="12" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Sustainability card description
                              </label>

                              <Controller
                                name={`sustainabilityCards.${index}.desc`}
                                control={control}
                                rules={{ required: "Please enter a sustainability Card description" }}
                                render={({ field }) => (
                                  <CKEditorNew
                                    field={field.name}
                                    setFieldValue={setValue}
                                    value={field.value}
                                    error={errors?.sustainabilityCards?.[index]?.desc}
                                    placeholder="Type your description here..."
                                  />
                                )}
                              />

                              {errors?.sustainabilityCards?.[index]?.desc && (
                                <span className="text-danger">
                                  {errors.sustainabilityCards[index].desc.message}
                                </span>
                              )}
                            </div>
                          </Col>


                          {/* Remove Button */}
                          <Col lg="12" className="text-right">
                            <Button
                              type="button"
                              variant="danger"
                              onClick={() => removeSustainabilityCardsDetail(index)}
                              className="mt-2"
                            >
                              <MdDelete />
                            </Button>
                          </Col>
                        </div>
                      ))}
                      <Col lg="12" className="text-right mt-3">
                        <Button
                          type="button"
                          color="primary"
                          onClick={() => appendSustainabilityCardsDetail({ image: "", desc: "", tittle: "" })}
                        >
                          <MdAdd />
                          Sustainability card
                        </Button>
                      </Col>

                    </Row>
                  </Tab.Pane>



                  {/* Submit Button */}
                  <Col lg="12" className="text-right my-3">
                    <Button
                      type="submit"
                      className="d-flex align-items-center justify-content-center commonBtn"
                      disabled={isUpdating}
                    >
                      Submit
                    </Button>
                  </Col>
                </Tab.Content>
              </Tab.Container>
            </Col>
          </Row>
        </div>
      </form>
    </Col>
  );
}

export default AboutAndSustainabilityContentForm;
